module.exports = __webpack_public_path__ + "static/media/s_v10_29.6be30a7d.mp3";